export var attributes = {
  email: 'E-posta',
  current_password: 'Mevcut şifre',
  password: 'Şifre',
  confirm_password: 'Şifre tekrar'
};